import { Button, Flex, Stack, Text, Title } from "@mantine/core";
import { Link } from "@tanstack/react-router";

const PageNotFound = () => {
  return (
    <Flex justify={"center"} pt={"xl"}>
      <Stack p={"lg"} maw={"770px"} w={"100%"}>
        <Flex direction="column" w={"100%"}>
          <Title>Sidan kunde inte hittas...</Title>
          <Text>
            Det kan bero på att du har skrivit in fel adress eller att sidan du
            söker har flyttat.
          </Text>
          <Button mt={"lg"} component={Link} to="/home">
            Till startsidan
          </Button>
        </Flex>
      </Stack>
    </Flex>
  );
};

export default PageNotFound;
